import React, { useState } from "react";
import {
  Box,
  Card,
  Container,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PaidIcon from "@mui/icons-material/Paid";
import { useStyles } from "../../../theme/appStyles";
import BasePricingTable from "./Components/BasePricingTable";
import SpecialDatesTab from "./Components/SpecialDatesTab";

// ── Tab panel wrapper ──────────────────────────────────────────────────────────
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = ({ children, value, index }: TabPanelProps) => (
  <Box
    role="tabpanel"
    hidden={value !== index}
    id={`banquet-pricing-tabpanel-${index}`}
    aria-labelledby={`banquet-pricing-tab-${index}`}
  >
    {value === index && children}
  </Box>
);

// ── Page ───────────────────────────────────────────────────────────────────────
const BanquetPricing = () => {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();

  return (
    <Container
      maxWidth="xl"
      disableGutters={isMobile}
      sx={{ px: { xs: 0, sm: 1, md: 2 } }}
    >
      <Box sx={{ pb: { xs: 10, sm: 12 } }}>
        {/* Page heading */}
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 900,
            display: "flex",
            alignItems: "center",
            color: "text.primary",
            fontSize: { xs: 16, sm: 18, md: 20 },
            mb: 2,
          }}
        >
          <PaidIcon
            sx={{
              mr: 1,
              width: { xs: 22, sm: 26, md: 28 },
              height: { xs: 22, sm: 26, md: 28 },
            }}
          />
          Banquet Hall Pricing
        </Typography>

        {/* Tab card */}
        <Card className={classes.card} sx={{ p: 0, overflow: "hidden" }}>
          {/* Tab strip */}
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              px: { xs: 1, sm: 2 },
              pt: 1,
              bgcolor: "background.paper",
            }}
          >
            <Tabs
              value={activeTab}
              onChange={(_, v) => setActiveTab(v)}
              variant={isMobile ? "fullWidth" : "standard"}
              aria-label="Banquet pricing tabs"
            >
              <Tab
                label="Base Pricing"
                id="banquet-pricing-tab-0"
                aria-controls="banquet-pricing-tabpanel-0"
              />
              <Tab
                label="Special Dates"
                id="banquet-pricing-tab-1"
                aria-controls="banquet-pricing-tabpanel-1"
              />
            </Tabs>
          </Box>

          {/* Tab content */}
          <TabPanel value={activeTab} index={0}>
            <BasePricingTable />
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <SpecialDatesTab />
          </TabPanel>
        </Card>
      </Box>
    </Container>
  );
};

export default BanquetPricing;
